<template>
    <div v-if="!value.oblivion">
      
               <div class="form-row position-relative">
           
            <!--div class="position-absolute text-right d-block more-options-menu"  v-on:mouseover="hover=true"   v-on:mouseleave="hover = false" v-if="!readOnly">
                <ul class="list-inline">
                    <li class="list-inline-item text-center" v-if="hover && last">
                        <a v-on:click="addEmail" title="Aggiungi nuovo indirizzo email"  >
                            <font-awesome-icon icon="plus"></font-awesome-icon>
                        </a>
                    </li>
                    <li class="list-inline-item text-center"  v-if="hover && !first">
                        <a v-on:click="removeEmail" title="Rimuovi indirizzo email"  class="text-danger">
                            <font-awesome-icon icon="times"></font-awesome-icon>
                        </a>
                    </li>
                    <li class="list-inline-item text-center"  v-if="!hover">
                        <a  class="text-mute">
                            <font-awesome-icon icon="ellipsis-v"></font-awesome-icon>
                        </a>
                    </li>

                </ul>
            </div-->
            <label class="col-11 col-form-label d-relative" :for="value.emailId">
                 <editable-label :label="value.label" @update-label="upddateLabel" :index="index" defaultLabel="Indirizzo email" :readOnly="readOnly || value.isImported"></editable-label>
                <a v-on:click="toggleDefault" class="ml-2" v-bind:class="{ 'text-warning': value.default, 'text-muted': !value.default }">
                    <font-awesome-icon icon="star"></font-awesome-icon>
                </a>
                <a v-on:click="toggleCertified" class=" ml-2" v-bind:class="{ 'text-warning': value.certified, 'text-muted': !value.certified }">
                    <font-awesome-icon icon="shield-alt"></font-awesome-icon>
                </a>


            </label>
            <div class="col-1">
                <div class="dropdown" v-if="!readOnly">
                  <button
                    class="btn btn-link l-h-20 p-0 font-18 float-right"
                    type="button"
                    id="CustomdropdownMenuButton8"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <i class="feather icon-more-horizontal-"></i>
                  </button>
                  <div
                    class="dropdown-menu dropdown-menu-right"
                    aria-labelledby="CustomdropdownMenuButton8"
                  >
                    <a class="dropdown-item font-13 nav-link" v-on:click.stop="addEmail" ><i class="feather icon-plus"></i> Aggiungi Email </a>
               
                    <a class="dropdown-item font-13 text-danger cursor-pointer nav-link"  v-on:click.stop="removeEmail"  v-if="!first && !value.isImported && !readOnly"><i class="feather icon-trash"></i> Elimina</a>
                  </div>
                </div>
            </div>
            <div class="col">
                <ValidationProvider rules="email" v-slot="{ classes }"   v-if="!readOnly && !value.isImported && !value.Oblivion">
                    <input type="text" :id="value.emailId" :name="value.emailId" placeholder="Indirizzo mail" v-model="value.email" class="form-control" :class="classes">
                </ValidationProvider>
   
                <span v-if="(readOnly || value.isImported ) &&  !value.oblivion && value.email!=''" class="cursor btn-link" @click="sendCommunication">
                    {{value.email}}
                </span>
              
            </div>
        </div>
           
          
        </div>

       

</template>
<script>

export default {
        name: 'emailaddress',
       
        props: {
            readOnly: {
                type: Boolean,
                required: false,
                default:() => false
            },
             last: {
                type: Boolean,
                required: true,
                default:() => false
            },
              first: {
                type: Boolean,
                required: false,
                default:() => false
            },
            value: {
                type: Object,
                required: false,
                
            },
            index: {
                type: Number,
                required: false,
                default:()=>0
            }
        },
      
        components: {
           
        },
        data() {
            return {
                hover:false
            }
        },
        methods: {
            mouseOver: function () {
                
            },
            updateEmailAddress: function (v) {
                this.value.email = v
               // this.$emit('input', this.value)
            },
            upddateLabel: function (label) {
               
                this.value.label = label;
                // this.$emit('input', this.value)
            }
            , toggleDefault: function () {
               
                this.value.default = !this.value.default;
                 this.$emit('update-default', this.value)
            }
             , sendCommunication: function () {
               
                 this.$emit('send-email', this.value)
            }
             , removeEmail: function () {
               
                
                 this.$emit('remove-email', this.value)
            }

              , addEmail: function () {
               
               
                 this.$emit('add-email');
                
            }
             , toggleCertified: function () {
               
                this.value.certified = !this.value.certified;
                // this.$emit('input', this.value)
            }
        }
}
</script>

<style lang="css">
  .nav-link {
    cursor:pointer;
  }
</style>
